module.exports = __webpack_public_path__ + "img/cover-slot-bg.aa7cf3e3.jpg";